import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState, useRef } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";
import MsgIcon from "../../../../../assets/svg/dashboard/Icon_Message_White.svg";
import LineWithDot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import MessagesTable from "./MessagesTable";
import machines from "./rightbottom.svg";
import useStyles from "./style";
import Sidebar from "./sidebar";
// import Sidebar from "../../MentorDashboard/MentorMessages/sidebar";
import Chatbox from "./chatbox";
import "./style.scss";
import NewConversation from "./newConversation";
import {
  ALL_CONVERSATION,
  MESSAGES,
  MY_MENTORSHIP_LIST,
  SEND_MESSAGE,
  ALL_CONVERSATION_GROUP,
} from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import { Avatar, Menu, MenuItem, Tooltip } from "@material-ui/core";
import Modal from "./Modal/modal";
import ViewModal from "./ViewModal/modal";
import messageIcon from "./messageIcon.svg";
import clsx from "clsx";

// : "#838186"

const MentorMessages = (props) => {
  const classes = useStyles(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [data, setData] = useState();
  const [groupdata, setGroupData] = useState();

  const [chatData, setChatData] = useState();
  const [taggingList, setTaggingList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [activeChat, setActiveChat] = useState();
  const [didDataChange, setDidDataChange] = useState(1);
  const [file, setFile] = useState(null);
  const [newMenu, setNewMenu] = useState();
  const [clickedTab, setClickedTab] = useState(false);

  const [newChatMode, setNewChatMode] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [myMentorships, setMyMentorships] = useState();
  const [datumidgroup, setdatumidgroup] = useState("");
  const [datumidconvo, setdatumidconvo] = useState("");
  const [clickedGroupName, setclickedGroupName] = useState(false);
  const [clickedIndiName, setclickedIndiName] = useState(true);
  const [messageuserrole, setMessageuserrole] = useState("");

  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const getMyMentorshipList = () => {
    api
      .POST(MY_MENTORSHIP_LIST, {
        requestedBy: value?.id,
      })
      .then((res) => {

setNewMenu(res?.data?.data)
        setMyMentorships(res.data?.data);
      })
      .catch((err) => {});
  };

  const getAllConversations = () => {
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

    api
      .POST(ALL_CONVERSATION, {
        senderId: value?.id,
      })
      .then((res1) => {
        let arr1 = res1.data?.data?.map((obj) => ({
          ...obj,
          lastUpdated: new Date(obj.lastUpdated),
        }));
        const sortedDesc = arr1.sort(
          (objA, objB) => Number(objB.lastUpdated) - Number(objA.lastUpdated)
        );

        setData(sortedDesc);

        api
          .POST(MY_MENTORSHIP_LIST, {
            requestedBy: value?.id,
          })
          .then((res) => {
            let newConversations = res.data?.data?.filter((ele) => {
              let isTrue = true;
              res1.data?.data?.forEach((element) => {
                let otherPartyId =
                  element?.bpartyId === value?.id
                    ? element?.apartyId
                    : element?.bpartyId;
                if (ele.mentorId == otherPartyId) isTrue = false;
              });
              return isTrue;
            });

            setNewMenu(newConversations);
          })
          .catch((err) => {

          });
      })
      .catch((err) => {});
  };

  const getAllConversationsGroups = () => {
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

    // axios({
    //   url: ALL_CONVERSATION_GROUP,
    //   method: "post",
    //   data: {
    //     senderId: value?.id,
    //   },
    // })
    api
      .POST(ALL_CONVERSATION_GROUP, {
        senderId: value?.id,
      })
      .then((res2) => {
        let arr1 = res2.data?.data?.map((obj) => ({
          ...obj,
          lastUpdated: new Date(obj.lastUpdated),
        }));
        const sortedDesc = arr1.sort(
          (objA, objB) => Number(objB.lastUpdated) - Number(objA.lastUpdated)
        );

        // setData(sortedDesc);
        setGroupData(sortedDesc);
      })
      .catch((err) => {});
  };

  const getChats = () => {
    if (activeChat) {
      const receiverId =
        activeChat.bpartyId === value?.id
          ? activeChat.apartyId
          : activeChat.bpartyId;
      // axios({
      //   url: MESSAGES,
      //   method: "post",
      //   data: {
      //     id: value?.id,
      //     senderId: value?.id,
      //     receiverId,
      //     pageFilter: {
      //       currentPage: 0,
      //       includeCount: true,
      //       pageSize: 1000,
      //       sortField: "createdDate",
      //       sortOrder: "DESC",
      //     },
      //   },
      // })
      api
        .POST(MESSAGES, {
          id: value?.id,
          senderId: value?.id,
          receiverId,
          pageFilter: {
            currentPage: 0,
            includeCount: true,
            pageSize: 1000,
            sortField: "createdDate",
            sortOrder: "DESC",
          },
        })
        .then((res) => {
          setChatData(res.data?.data);
        })
        .catch((err) => {});
    }
  };

  const getChatsGroups = () => {
    if (activeChat) {
      const groupId = activeChat.id;
      // axios({
      //   url: MESSAGES,
      //   method: "post",
      //   data: {
      //     // id: value?.id,
      //     senderId: value?.id,
      //     groupId: groupId,
      //     pageFilter: {
      //       currentPage: 0,
      //       includeCount: true,
      //       pageSize: 1000,
      //       sortField: "createdDate",
      //       sortOrder: "DESC",
      //     },
      //   },
      // })
      api
        .POST(MESSAGES, {
          // id: value?.id,
          senderId: value?.id,
          groupId: groupId,
          pageFilter: {
            currentPage: 0,
            includeCount: true,
            pageSize: 1000,
            sortField: "createdDate",
            sortOrder: "DESC",
          },
        })
        .then((res) => {
          setChatData(res.data?.data);
        })
        .catch((err) => {});
    }
  };

  useEffect(() => {
    setTimeout(() => {
      localStorage.removeItem("myRequests");
      localStorage.removeItem("startupAllMentorList");
      localStorage.removeItem("mentorStartupRequest");
      localStorage.removeItem("startUpRequests");
      localStorage.removeItem("CohortStartupRequest");
      localStorage.removeItem("cohortMentorshipsStartup");
    }, 1000);
    getAllConversations();
    getMyMentorshipList();
    getAllConversationsGroups();

    // const myInterval = setInterval(getAllConversations, 5000);
    const myInterval = setInterval(
      clickedTab === false ? getAllConversations : getAllConversationsGroups,
      5000
    );
    // const myInterval2 = setInterval(getChats, 1000);
    return () => {
      clearInterval(myInterval);
      // clearInterval(myInterval2);
    };
  }, [clickedTab]);

  useEffect(() => {
    // const myInterval = setInterval(getChats, 1000);

    const myInterval = setInterval(
      clickedTab === false ? getChats : getChatsGroups,
      1000
    );
    return () => {
      clearInterval(myInterval);
    };
  }, [activeChat]);

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    //
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  };

  const onTransitionFromNewMode = () => {
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    if (clickedTab === false) {
      // axios({
      //   url: ALL_CONVERSATION,
      //   method: "post",
      //   data: {
      //     senderId: value?.id,
      //   },
      // })
      api
        .POST(ALL_CONVERSATION, {
          senderId: value?.id,
        })
        .then((res1) => {
          setData(res1.data?.data);
          res1.data?.data?.forEach((conversation) => {
            let otherPartyId =
              conversation?.bpartyId === value?.id
                ? conversation?.apartyId
                : conversation?.bpartyId;
            if (otherPartyId === activeChat.bpartyId) {
              onConversationClick(otherPartyId, conversation);
            }
          });

          api
            .POST(MY_MENTORSHIP_LIST, {
              requestedBy: value?.id,
            })
            .then((res) => {
              let newConversations = res.data?.data?.filter((ele) => {
                let isTrue = true;
                res1.data?.data?.forEach((element) => {
                  let otherPartyId =
                    element?.bpartyId === value?.id
                      ? element?.apartyId
                      : element?.bpartyId;
                  if (ele.mentorId == otherPartyId) isTrue = false;
                });
                return isTrue;
              });
              setNewMenu(newConversations);
            })
            .catch((err) => {});
        })
        .catch((err) => {});
    } else {
      // axios({
      //   url: ALL_CONVERSATION_GROUP,
      //   method: "post",
      //   data: {
      //     senderId: value?.id,
      //   },
      // })
      api
        .POST(ALL_CONVERSATION_GROUP, {
          senderId: value?.id,
        })
        .then((res1) => {
          setGroupData(res1.data?.data);
          res1.data?.data?.forEach((conversation) => {
            let otherPartyIdnew = conversation?.id;
            //     ? conversation?.apartyId
            //     : conversation?.bpartyId;
            // if (otherPartyId === activeChat.bpartyId) {

            onConversationClick(otherPartyIdnew, conversation);
            // }
          });

          
        })
        .catch((err) => {});
    }
  };

  const onConversationClick = (receiverId, receiverData) => {
    setActiveChat(receiverData);

    if (
      clickedTab === false
      // individualclickedName === true &&
      // cohortclickedName === false
    ) {
      // axios({
      //   url: MESSAGES,
      //   method: "post",
      //   data: {
      //     id: value?.id,
      //     senderId: value?.id,
      //     receiverId,
      //     pageFilter: {
      //       currentPage: 0,
      //       includeCount: true,
      //       pageSize: 1000,
      //       sortField: "createdDate",
      //       sortOrder: "DESC",
      //     },
      //   },
      // })
      api
        .POST(MESSAGES, {
          id: value?.id,
          senderId: value?.id,
          receiverId,
          pageFilter: {
            currentPage: 0,
            includeCount: true,
            pageSize: 1000,
            sortField: "createdDate",
            sortOrder: "DESC",
          },
        })
        .then((res) => {
          setChatData(res.data?.data);
          scrollToBottom();
        })
        .catch((err) => {});
    } else {
      // axios({
      //   url: MESSAGES,
      //   method: "post",
      //   data: {
      //     // id: value?.id,
      //     senderId: value?.id,
      //     groupId: receiverData?.id,
      //     pageFilter: {
      //       currentPage: 0,
      //       includeCount: true,
      //       pageSize: 1000,
      //       sortField: "createdDate",
      //       sortOrder: "DESC",
      //     },
      //   },
      // })
      api
        .POST(MESSAGES, {
          // id: value?.id,
          senderId: value?.id,
          groupId: receiverData?.id,
          pageFilter: {
            currentPage: 0,
            includeCount: true,
            pageSize: 1000,
            sortField: "createdDate",
            sortOrder: "DESC",
          },
        })
        .then((res) => {
          // setindividualclickedName(false);
          // setcohortclickedName(false);
          // setclickedGroupName(true);
          setChatData(res.data?.data);
          scrollToBottom();
        })
        .catch((err) => {});
    }
  };

  const onSubmitMessage = () => {
    if ((!inputValue && !file) || !activeChat) {
      return;
    }

    const receiverId =
      activeChat?.bpartyId === value?.id
        ? activeChat?.apartyId
        : activeChat?.bpartyId;
    const formData = new FormData();
    if (inputValue && clickedTab === false) {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          receiverId,
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: inputValue,
          },
          taggingList: [receiverId],
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    } else if (inputValue && clickedTab === true) {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          groupId: activeChat?.id,
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: inputValue,
          },
          taggingList: [receiverId],
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    } else {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          receiverId,
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: "",
          },
          taggingList: [receiverId],
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    }
    if (file) {
      formData.append("commentFile", file, file?.name);
    }
    // axios({
    //   url: SEND_MESSAGE,
    //   method: "post",
    //   data: formData,
    // })
    api
      .POST(SEND_MESSAGE, formData)
      .then((res) => {
        if (newChatMode) {
          setNewChatMode(false);
          onTransitionFromNewMode();
        }
        setChatData([...chatData, res.data?.data]);
        scrollToBottom();
      })
      .catch((err) => {});
    setTaggingList([]);
    setInputValue("");
    setFile(null);
  };
  const onBroadcastMessage = () => {
    if (!inputValue && !file) {
      return;
    }
    let newTaggingList;
    if (taggingList?.length > 0) {
      newTaggingList = taggingList;
    } else {
      return;
    }
    // newTaggingList.map(tlist => {

    // })

    const formData = new FormData();
    if (inputValue) {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          receiverId: taggingList[0],
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: inputValue,
          },
          taggingList,
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    } else {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          receiverId: taggingList[0],
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: "",
          },
          taggingList,
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    }
    if (file) {
      formData.append("commentFile", file, file?.name);
    }
    // axios({
    //   url: SEND_MESSAGE,
    //   method: "post",
    //   data: formData,
    // })
    api
      .POST(SEND_MESSAGE, formData)
      .then((res) => {})
      .catch((err) => {});

    setModalOpen(false);
    setTaggingList([]);
    setInputValue("");
    setFile(null);
  };

  const onAttachFile = (e) => {
    setFile(e.target.files[0]);
  };

  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.mentorId) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.mentorId]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.mentorId);
        setTaggingList(newArray);
      }
    }
  };
  const [viewModalOpen, setViewModalOpen] = useState(false);

  return (
    <Box className={classes.root}>
      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        myMentorships={myMentorships}
        onSubmitMessage={onBroadcastMessage}
        inputValue={inputValue}
        setInputValue={setInputValue}
        setTaggingList={setTaggingList}
        file={file}
        on
        onAttachFile={onAttachFile}
        onBroadcastSelectionChange={onBroadcastSelectionChange}
        taggingList={taggingList}
      />
      <ViewModal modalOpen={viewModalOpen} setModalOpen={setViewModalOpen} />
      <Box className={clsx(classes.absoluteTop, "mymsgsstartuploginhead")}>
        <Typography className={clsx(classes.headingOne, "headming1")}>
          MAARG Portal by Startup India
        </Typography>
        <Typography className={classes.headingTwo}>MY MESSAGES</Typography>
        <Typography
          style={{
            textAlign: "center",
            marginBottom: "40px",
            padding: "0  8%",
            fontFamily: "Montserrat",
            color: "rgba(0,0,0,0.5)",
            fontWeight: "bold",
            fontSize: "18px",
            color: "#6f59a6",
          }}
        >
          Note: All conversations will be recorded for quality purposes
        </Typography>
        <Tooltip
          classes={{
            tooltip: classes.tooltip,
            tooltipArrow: classes.tooltipArrow,
          }}
          PopperProps={{
            disablePortal: true,
          }}
          placement="left"
          arrow
          title={
            <Typography
              style={{
                fontFamily: "Montserrat",
                fontSize: "16px",
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              Click here to Send Broadcast Message
            </Typography>
          }
        >
          <div
            className={clsx(
              "dashboard-purple-btn top-btn sendbroadcastagain",
              classes.imageButton
            )}
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <span
              className={clsx("blue-link-dashboard", "fontpurposemobole")}
              onClick={() => {}}
              style={{
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Send Broadcast Message
            </span>
          </div>
          {/* <img
            className={classes.imageButton}
            src={messageIcon}
            onClick={() => {
              setModalOpen(true);
            }}
          /> */}
        </Tooltip>
        <Tooltip
          classes={{
            tooltip: classes.tooltip,
            tooltipArrow: classes.tooltipArrow,
          }}
          PopperProps={{
            disablePortal: true,
          }}
          placement="left"
          arrow
          title={
            <Typography
              style={{
                fontFamily: "Montserrat",
                fontSize: "16px",
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              Click here to View Broadcast Messages
            </Typography>
          }
        >
          <div
            // style={{ marginTop: "61px" }}
            className={clsx(
              "dashboard-purple-btn top-btn sendbroadcastagain newagainbtn",
              classes.imageButton1
            )}
            onClick={() => {
              setViewModalOpen(true);
            }}
          >
            <span
              className="blue-link-dashboard fontpurposemobole"
              onClick={() => {}}
              style={{
                paddingRight: "0px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              View Broadcast Messages
            </span>
          </div>
          {/* <img
            className={classes.imageButton1}
            src={messageIcon}
            onClick={() => {
              setViewModalOpen(true);
            }}
          /> */}
        </Tooltip>
      </Box>
      <Sidebar
        setMessageuserrole={setMessageuserrole}
        clickedTab={clickedTab}
        setClickedTab={setClickedTab}
        activeChat={activeChat}
        onConversationClick={onConversationClick}
        // data={data}
        data={clickedTab === false ? data : groupdata}
        indidata={data}
        grpdata={groupdata}
        setNewChatMode={setNewChatMode}
        datumidgroup={datumidgroup}
        datumidconvo={datumidconvo}
        setdatumidgroup={setdatumidgroup}
        setdatumidconvo={setdatumidconvo}
        setclickedGroupName={setclickedGroupName}
        setclickedIndiName={setclickedIndiName}
      />
      <Chatbox
        messageuserrole={messageuserrole}
        onSubmitMessage={onSubmitMessage}
        inputValue={inputValue}
        setInputValue={setInputValue}
        file={file}
        on
        activeChat={activeChat}
        chatData={chatData}
        anchorElement={<div ref={messagesEndRef} />}
        onAttachFile={onAttachFile}
        clickedTab={clickedTab}
        setClickedTab={setClickedTab}
        clickedGroupName={clickedGroupName}
        clickedIndiName={clickedIndiName}
      />
      <NewConversation
        newMenu={newMenu}
        setActiveChat={setActiveChat}
        setChatData={setChatData}
        setNewChatMode={setNewChatMode}
      />
    </Box>
  );
};

export default MentorMessages;
